/* eslint-disable global-require */
import AuthContext from 'context/auth/authContext'
import Background from 'assets/img/wic/Fruits_slides.jpg'
import React, { useContext, useEffect, useState, useRef } from 'react'
import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Form,
  Row,
} from 'reactstrap'
import aplssLogo from 'assets/img/wic/APLSS Logo Variants-02.png'
import { useHistory } from 'react-router-dom'
import NotificationAlert from 'react-notification-alert'
import { useOktaAuth } from '@okta/okta-react'

const LoginPage = () => {
  const history = useHistory()

  const [user] = useState({
    Username: '',
    password: '',
  })

  const [userVerification, setUserVerification] = useState({
    Username: '',
    password: '',
  })

  const { oktaAuth, authState } = useOktaAuth()

  const loginWithOkta = async () => oktaAuth.signInWithRedirect()

  const { Username, password } = user

  const authContext = useContext(AuthContext)

  const { login, loadUser, error, clearErrors } = authContext

  const notificationAlert = useRef()
  const notify = () => {
    let options = {
      place: 'bc',
      message: (
        <div>
          <h5>{error}.</h5>
        </div>
      ),
      type: 'danger',
      icon: 'nc-icon nc-bell-55',
      autoDismiss: 3,
    }
    notificationAlert.current.notificationAlert(options)
  }

  useEffect(() => {
    loadUser()

    document.body.classList.toggle('login-page')

    if (authState?.isAuthenticated) {
      history.push('/submission/dashboard')
    }

    if (error) {
      notify()
      clearErrors()
    }

    return () => {
      document.body.classList.toggle('login-page')
    }
    // eslint-disable-next-line
  }, [history, authState?.isAuthenticated, error])

  const loginClick = e => {
    e.preventDefault()

    if (user.Username === '') {
      setUserVerification({ ...userVerification, Username: 'has-danger' })
    } else if (user.password === '') {
      setUserVerification({ ...userVerification, password: 'has-danger' })
    } else {
      login({ Username, password })
    }
  }

  const registerClick = e => {
    e.preventDefault()
    history.push('/auth/register')
  }

  return (
    <div className="login-page">
      <Container>
        <NotificationAlert ref={notificationAlert} />
        <Row>
          <Col className="ml-auto mr-auto" lg="4" md="6">
            <Form id="loginForm" onSubmit={loginClick}>
              <Card className="card-login">
                <CardHeader>
                  <CardHeader>
                    <h3 className="header text-center">
                      <img src={aplssLogo} alt="APLSS" />
                    </h3>
                  </CardHeader>
                </CardHeader>

                <CardFooter>
                  <Button
                    block
                    className="btn-round mb-3"
                    color="success"
                    type="submit"
                    onClick={loginWithOkta}
                  >
                    Log In
                  </Button>
                  <Button
                    block
                    className="btn-round mb-3"
                    color="danger"
                    onClick={registerClick}
                  >
                    Register
                  </Button>
                </CardFooter>
                <a href="/auth/forgotpassword" className="text-center" type="">
                  Forgot password?
                </a>
              </Card>
            </Form>
          </Col>
        </Row>
      </Container>
      <div
        className="full-page-background"
        style={{
          backgroundImage: `url(${Background})`,
          opacity: 0.4,
        }}
      />
    </div>
  )
}

export default LoginPage
